// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';

// types
import { type CommissionPaid } from '.';
import {
  type Currency,
  type Currencies,
  type TooltipProps
} from '../../../utilities/types';
import { Desktop } from '../../../components/Responsive';
import { ModelListTd } from '../../../components/ModelListStyles';
import { DefaultIcon } from '../../../components/Icon';
import { formatCurrency } from '../../../utilities/numberFormatting';
import { history } from '../../../utilities/history';
import { formatDate } from '../../../utilities/misc';
import DefaultModelRowTr from '../../../modules/CrudTable/components/DefaultModelRowTr';
import IconWithText from '../../../components/IconWithText';
import { showTooltip } from './reducer';
import { StatusP } from './CommissionPaidIndexStyles';
import RequiresAction from '../components/paid/RequiresAction';
import { makeGetCryptoWallet } from './selectors';

type Props = {
  data: CommissionPaid,
  currency: Currency,
  currencies: Currencies,
  index: number,
  requiresBankAccount: boolean,
  cryptoWallet: string,
  ...$Exact<TooltipProps>
};
class TableRow extends Component<Props> {
  handleTableDetail = () => {
    history.push({
      pathname: `/commission-payouts/paid/${this.props.data.id}`,
      state: {
        prevPath: '/commission-payouts/paid',
        iso: this.props.data.currency
      }
    });
  };

  handleRequiresAction = (cb: Function) => {
    const color = this.props.data.status === 'pending' ? 'orange' : 'green';
    return (
      <IconWithText
        message={cb}
        label={this.props.data.status}
        icon="warning"
        iconColor="red"
        labelColor={color}
        activeTooltip={this.props.activeTooltip}
        tooltipName={`STATUS_TOOLTIP_${this.props.index}`}
        showTooltip={this.props.showTooltip}
        smallIcon
      />
    );
  };

  defaultRender = () => {
    const color = this.props.data.status === 'pending' ? 'orange' : 'green';

    return <StatusP color={color}>{this.props.data.status}</StatusP>;
  };

  render() {
    const currency = this.props.currencies[this.props.data.currency];
    const currencyName =
      currency.currency_type === 'fiat' ? currency.iso4217 : currency.name;

    return (
      <DefaultModelRowTr
        key={this.props.index}
        onClick={this.handleTableDetail}
        hoverStylesMobile
        hoverStyles
      >
        <Desktop>
          <ModelListTd>
            <DefaultIcon
              name={currency.iso4217.toLowerCase()}
              color={currency.color}
            />{' '}
            {currencyName}
          </ModelListTd>
        </Desktop>
        <ModelListTd>{formatDate(this.props.data.created_at)}</ModelListTd>
        <ModelListTd right>
          {formatCurrency(this.props.data.amount, currency)}
        </ModelListTd>
        <ModelListTd capitalize right>
          <RequiresAction
            status={this.props.data.status}
            requiresCryptoWallet={!this.props.cryptoWallet}
            requiresBankAccount={this.props.requiresBankAccount}
            currencyName={currencyName}
            currencyType={currency.currency_type}
            handleRequiresAction={this.handleRequiresAction}
            defaultRender={this.defaultRender()}
          />
        </ModelListTd>
      </DefaultModelRowTr>
    );
  }
}

const makeMapStateToProps = () => {
  const getCryptoWallet = makeGetCryptoWallet();

  const mapStateToProps = (state, ownProps) => ({
    cryptoWallet: getCryptoWallet(state, ownProps),
    requiresBankAccount: state.account.bankAccount.formState === 'create', //TODO: make call in saga
    activeTooltip: state.commissionPayouts.commissionPaid.index.activeTooltip
  });
  return mapStateToProps;
};

const mapDispatchToProps = {
  showTooltip
};

export default connect(makeMapStateToProps, mapDispatchToProps)(TableRow);
